import { b as attachEvent, p as getNodeAttrs, s as setNodeAttrs } from '../../selectors-f64b5778.js';
import '../../typeof-92b42de1.js';
import '../../slicedToArray-26803f33.js';
import '../../unsupportedIterableToArray-577176bf.js';
import '../../toConsumableArray-2a2700d9.js';
import '../../defineProperty-18999f8e.js';
import '../../configs/index.js';

var attachDragBoundEvents = function attachDragBoundEvents(layer) {
  return attachEvent(layer.renderable, 'dragmove', function () {
    var dragBounds = layer.dragBounds,
        node = layer.renderable;
    if (!dragBounds) return;

    var _getNodeAttrs = getNodeAttrs(node),
        nodeX = _getNodeAttrs.x,
        nodeY = _getNodeAttrs.y;

    var minX = dragBounds.minX,
        minY = dragBounds.minY,
        maxX = dragBounds.maxX,
        maxY = dragBounds.maxY;
    var xToSet = nodeX < minX ? minX : nodeX > maxX ? maxX : nodeX;
    var yToSet = nodeY < minY ? minY : nodeY > maxY ? maxY : nodeY;
    setNodeAttrs(node, {
      x: xToSet,
      y: yToSet
    });
  });
};

export { attachDragBoundEvents as default };
